/**
 * Kullanıcının admin rolünde olup olmadığını belirler.
 *
 * Backend `role` alanını string veya obje olarak dönebiliyor
 * (api-types: `role: string | object`); her iki biçim de büyük/küçük
 * harf duyarsız karşılaştırılır. Admin-only istekler (ör. /contact/stats)
 * yalnızca bu kontrolü geçen kullanıcılar için yapılır.
 */
export const isAdminUser = (
  user: { role?: string | { name?: string } | null } | null | undefined,
): boolean => {
  const role = user?.role;
  if (!role) return false;

  const value = typeof role === "string" ? role : (role.name ?? "");
  return value.toLowerCase() === "admin";
};
